import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import Table from '../../../common/Table';
import Alert from '../../../common/informative/Alert';
import Loader from '../../../common/Loader';
import DateCell from '../../../common/cells/DateCell';
import Breadcrumbs from '../../../layout/Breadcrumbs';
import {
  getAccountingReport,
  clearAccountingReport,
  clearErrorGettingAccountingReport,
} from '../../../../actions';
import { ACCOUNTING_REPORTS_PATH } from '../../../../config/paths';
import ReportToolbar from '../ReportToolbar';
import {
  matchPropTypes,
  breadcrumbsPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { DATE_TIME_FORMAT } from '../../../../config/locale';

class AccountingReport extends Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        Header: 'Número correlativo',
        accessor: 'uniqueId',
      },
      {
        Header: 'Fecha de envío',
        accessor: 'saleDate',
        Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
      },
      {
        Header: 'Fecha de venta',
        accessor: 'expirationDate',
        Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
      },
      {
        Header: 'Tipo (Tabla 10)',
        accessor: 'saleType',
      },
      {
        Header: 'N° Serie',
        accessor: 'documentSeries',
      },
      {
        Header: 'Número',
        accessor: 'documentCode',
      },
      {
        Header: 'Tipo (Tabla 2)',
        accessor: 'identityDocumentType',
      },
      {
        Header: 'Número',
        accessor: 'identityDocumentNumber',
      },
      {
        Header: 'Apellidos y Nombres/Denominación o Razon Social',
        accessor: 'identityDocumentName',
      },
      {
        Header: 'Valor Facturado de la exportación',
        accessor: 'exportValue',
      },
      {
        Header: 'Base imponible de la operación gravada',
        accessor: 'taxableValue',
      },
      {
        Header: 'Exonerada',
        accessor: 'exoneratedValue',
      },
      {
        Header: 'Inafecta',
        accessor: 'inaffectedTaxValue',
      },
      {
        Header: 'ISC',
        accessor: 'isc',
      },
      {
        Header: 'IGV y/o IPM',
        accessor: 'igv',
      },
      {
        Header: 'IGV y/o IPM',
        accessor: 'igv',
      },
      {
        Header: 'Otros Tributos',
        accessor: 'otherTax',
      },
      {
        Header: 'Otros Tributos',
        accessor: 'otherTax',
      },
      {
        Header:
          'Otros Tributos y cargos que no forman parte de la base imponible',
        accessor: 'otherTax',
      },
      {
        Header: 'Importe total del comprobante de pago',
        accessor: 'printedOnTicketValue',
      },
      {
        Header: 'Tipo de cambio',
        accessor: 'exchangeRate',
      },
      {
        Header: 'Fecha',
        accessor: 'referenceDate',
      },
      {
        Header: 'Tipo',
        accessor: 'referenceSaleType',
      },
      {
        Header: 'Serie',
        accessor: 'referenceDocumentSeries',
      },
      {
        Header: 'N° del comprobante de pago o Documento',
        accessor: 'accountingReportId',
      },
    ];
    this.download = this.download.bind(this);
  }
  componentWillMount() {
    // extract id from params injected by react router
    const { id } = this.props.match.params;
    this.props.getAccountingReport({ id });
  }
  componentWillUnmount() {
    this.props.clearErrorGettingAccountingReport();
    this.props.clearAccountingReport();
  }
  download() {
    const { report } = this.props;
    const { id } = this.props.match.params;
    if (report) {
      return this.props.getAccountingReport({
        id,
        reportFormat: 'csv',
        download: true,
      });
    }
    return false;
  }
  renderContent() {
    // check if report is loaded
    const { loading, report, error } = this.props;

    // check if there is an error
    if (error) {
      return <Alert message={error} />;
    }

    // check if report is loading or empty
    if (loading || !report || report.isEmpty()) {
      return <Loader />;
    }

    // check if report is complete
    const reportStatus = report.get('reportStatus');
    if (reportStatus === 'GENERATING') {
      return <Loader />;
    }

    const accountingReportRows = report.get('accountingReportRows');
    let data = [];
    let pages = null;
    if (accountingReportRows) {
      data = accountingReportRows.content;
      pages = accountingReportRows.totalPages;
    }
    const { columns } = this;
    return (
      <div>
        <ReportToolbar download={this.download} disabled={!data.length} />
        <Table columns={columns} data={data} pages={pages} loading={loading} />
      </div>
    );
  }
  render() {
    return (
      <Container fluid>
        <Breadcrumbs breadcrumbs={this.props.breadcrumbs} />
        <h1>Reporte de Contabilidad</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
        {this.renderContent()}
      </Container>
    );
  }
}

const mapStateToProps = ({ ReportUnit }) => ({
  breadcrumbs: [
    ...ReportUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Contabilidad',
      href: ACCOUNTING_REPORTS_PATH,
    },
  ],
  error: ReportUnit.AccountingReport.get('current').get('error'),
  report: ReportUnit.AccountingReport.get('current').get('content'),
  loading: ReportUnit.AccountingReport.get('current').get('loading'),
});

const mapDispatchToProps = {
  getAccountingReport,
  clearAccountingReport,
  clearErrorGettingAccountingReport,
};

AccountingReport.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  getAccountingReport: PropTypes.func.isRequired,
  clearAccountingReport: PropTypes.func.isRequired,
  clearErrorGettingAccountingReport: PropTypes.func.isRequired,
  report: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  error: PropTypes.string,
  match: matchPropTypes.isRequired,
};

AccountingReport.defaultProps = {
  report: null,
  loading: false,
  error: null,
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountingReport);
